import React, { useEffect, useCallback, useState } from "react";
import {
  Button,
  Layout,
  Form,
  Input,
  notification,
  Select,
} from "antd";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import UserApi from "../../common/Apis/UserApi";
import { Row, Col } from "antd";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import RoleApi from "../../common/Apis/RoleApi";
const UserRole = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const urlParams = new URLSearchParams(window.location.search);
  const userEmail = urlParams.get("email");
  const [form] = Form.useForm();
  const [UserDetails, setUserDetails] = useState();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const getUserDetails = useCallback(() => {
    UserApi.TenantUserDetails(userEmail)
      .then((response) => {
        console.log(response?.payload);
        setUserDetails(response?.payload)
        form.setFieldsValue({
          userEmail: response?.payload?.email,
          firstName: response?.payload?.firstName,
          lastName: response?.payload?.lastName,
          RolesId: response?.payload?.roleDTOs[0]?.id,
        });

      })
      .catch((err) => { });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  const [AllRoles, setAllRoles] = React.useState([]);
  const getAllRoles = useCallback(() => {
    RoleApi.ListAllRoles()
      .then((response) => {
        setAllRoles(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getUserDetails();
    getAllRoles();
    PageLoading();
  }, [getUserDetails, PageLoading, getAllRoles]);

  const handleGoBack = () => {
    navigate(-1);
  };
  const handleSubmit = (data) => {

    let formData = JSON.stringify({
      id: UserDetails?.id,
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.userEmail,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      roleDTOs: [{ id: data?.RolesId }],
    });
    console.log(formData)
    UserApi.UserDetailsUpdate(UserDetails?.id, formData)
      .then((response) => {
        console.log(response);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Updated</span>,
          description: "Update Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });

        return navigate("/users");
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err?.apiError?.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <Form
            form={form}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col span={9}>
                  <Form.Item
                    name="firstName"
                    label="First Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter First Name",
                      },
                    ]}
                  >
                    <Input
                      readOnly
                      type="text"
                      placeholder="First Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={9}>
                  <Form.Item
                    name="lastName"
                    label="Last Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Last Name",
                      },
                    ]}
                  >
                    <Input
                      readOnly
                      type="text"
                      placeholder="Last Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={9}>
                  <Form.Item
                    name="userEmail"
                    label="Email"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Email",
                      },
                    ]}
                  >
                    <Input
                      readOnly
                      type="text"
                      placeholder="Email"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={9}>
                  <Form.Item
                    name="RolesId"
                    label="Roles :"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Roles.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Roles"
                    >
                      {(decodedToken?.roles?.includes("TENANT_ADMIN")) ? <>

                        <option value={4}>
                          Sub Tenant Admin
                        </option>
                        <option value={5}>
                          Sub Tenant User
                        </option>
                      </>
                        :
                        <>
                          {AllRoles && (
                            <>
                              {AllRoles?.map((option, index) => (
                                <option key={index} value={option?.id}>
                                  {option?.name}
                                </option>
                              ))}
                            </>
                          )}

                        </>
                      }

                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Update
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default UserRole;